<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'CBO-PAYMENTS'" [breadcrumb]="''" [count]="count"
    icon="fa-money-check-edit-alt">
</app-breadcrumb>

<!-- body -->
<div class="content-background p-0">
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab title="{{ 'CBO-PAYMENTS' | translate }}" [selected]="true">
            <ng-template kendoTabContent>
                <form novalidate [formGroup]="searchForm" class="k-form" style="overflow: hidden;" *ngIf="loaded">
                    <div class="row">
                        <div class="col-1 pt-3">
                            <label class="k-form-field">
                                <span class="k-text-uppercase dark" [ngClass]="{'k-disabled': !isAdmin}">
                                    {{ 'ALL' | translate }}
                                </span>
                                <input type="checkbox" [indeterminate]="allOrganizations.value === null"
                                    formControlName="allOrganizations" kendoCheckBox />
                            </label>
                        </div>
                        <div class="col-5">
                            <label class="k-form-field w-100">
                                <span class="k-text-uppercase dark" [ngClass]="{'k-disabled': allOrganizations.value}">
                                    {{'ORGANIZATION' | translate}} *
                                </span>
                                <kendo-multiselect id="cbos" [data]="cbosFiltered" formControlName="cbos"
                                    [textField]="'name'" [filterable]="true" [valueField]="'id'"
                                    (filterChange)="filterCBOs($event)" (close)="searchTerm=''" [autoClose]="true"
                                    [virtual]="virtualCBO">
                                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}"
                                            class="ellipsis-text">
                                        </span>
                                    </ng-template>
                                </kendo-multiselect>
                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                    *ngIf="cbos.hasError('required') && cbos.touched">
                                    {{'REQUIRED-ORGANIZATION' | translate}}
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <kendo-daterange>
                                <div class="k-form-field w-100" style="height:100px">
                                    <kendo-floatinglabel text="{{'FROM' | translate}} *" class="k-text-uppercase dark"
                                        style="margin-right: 15px;">
                                        <kendo-dateinput kendoDateRangeStartInput formControlName="fromDateSelection">
                                        </kendo-dateinput>
                                    </kendo-floatinglabel>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="fromDateSelection.hasError('required') && (fromDateSelection.touched || toDateSelection.touched)">
                                        {{'REQUIRED-FROM' | translate}}
                                    </div>
                                </div>
                                <div class="k-form-field w-100" style="height:100px">
                                    <kendo-floatinglabel text="{{'TO' | translate}} *" class="k-text-uppercase dark"
                                        style="position: relative; left: 7px;">
                                        <kendo-dateinput kendoDateRangeEndInput formControlName="toDateSelection"
                                            [max]="maxDate">
                                        </kendo-dateinput>
                                    </kendo-floatinglabel>
                                    <div class="k-tooltip k-tooltip-validation" role="alert"
                                        *ngIf="toDateSelection.hasError('required') && (fromDateSelection.touched || toDateSelection.touched)">
                                        {{'REQUIRED-TO' | translate}}
                                    </div>
                                </div>
                            </kendo-daterange>
                        </div>
                        <div class="col-3">
                            <label class="k-form-field w-100">
                                <span class="k-text-uppercase dark">{{'ORG-PAYMENT-STATUS' | translate}}
                                </span>
                                <kendo-multiselect id="orgPaymentStatus" [data]="orgPaymentStatusFiltered"
                                    formControlName="orgPaymentStatus" [textField]="'displayName'" [filterable]="true"
                                    [valueField]="'id'" (filterChange)="filterOrgPaymentStatuses($event)"
                                    (close)="searchTerm=''" [autoClose]="true">
                                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                        <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}"
                                            class="ellipsis-text">
                                        </span>
                                    </ng-template>
                                </kendo-multiselect>
                            </label>
                        </div>
                        <div class="col-3">
                            <div class="extra-top">
                                <button kendoButton type="button" [disabled]="!searchForm.valid || !searchForm.dirty"
                                    (click)="search($event)">
                                    {{'SEARCH' | translate}}<i class="far fa-search"></i>
                                </button>
                                <i class="fas fa-fw fa-times-circle fa-delete-custom ml-2"
                                    title="{{'SEARCH-CLEAR-ALL' | translate}}"
                                    [hidden]="!searchForm.valid || !searchForm.dirty" (click)="clearSearch()"
                                    style="font-size:20pt;position:relative;top:7px;padding-top:0;" tabindex="0"
                                    (keydown.enter)="clearSearch()" (keydown.space)="clearSearch()">
                                </i>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="row mt-2">
                    <div class="col-sm-12">
                        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                            <app-advanced-mode id="cboGridAdvancedSwitch" class="mr-4"
                                [storageKey]="'cbo-payments-list'" (collapsibleToggle)="enableAdvanced=$event">
                            </app-advanced-mode>
                        </div>
                    </div>
                </div>
                <div class="mt-2 ml-3 mr-3">
                    <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
                        [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                        [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
                        [filterable]="enableAdvanced" [filter]="view.state.filter" [selectable]="{ mode: 'single' }"
                        [kendoGridSelectBy]="'organizationId'" (selectedKeysChange)="onSelectedKeysChange($event)"
                        [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
                        (dataStateChange)="dataStateChange($event)" (dblclick)="dblClickInvoice($event)">
                        <kendo-grid-messages noRecords="{{ 'NO-ORGANIZATIONS' | translate }}">
                        </kendo-grid-messages>
                        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                            <button type="button" kendoGridExcelCommand [disabled]="count === 0">
                                {{'EXPORT-TO-EXCEL' | translate }}<i class="fal fa-file-excel"
                                    style="width: 15px;color:white"></i>
                            </button>
                        </ng-template>
                        <kendo-grid-column class="ellipsis-text" field="cbo" title="{{ 'ORGANIZATION' | translate }}"
                            [width]="140">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span title="{{dataItem.cbo}}">{{dataItem.cbo}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="totalUnits" [width]="90" filter="numeric" format="{0:n}"
                            title="{{ 'TOTAL-UNITS' | translate }}" class="text-right">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                                </kendo-grid-numeric-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="totalAmount" [width]="90" filter="numeric" format="n2"
                            title="{{ 'TOTAL-AMOUNT' | translate }}" class="text-right">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                                </kendo-grid-numeric-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="totalCount" [width]="120" filter="numeric" format="{0:n}"
                            title="{{ 'NUMBER-OF-RECORDS' | translate }}" class="text-right">
                            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                                </kendo-grid-numeric-filter-cell>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-excel fileName="ORGPayments.xlsx" [fetchData]="allData"></kendo-grid-excel>
                    </kendo-grid>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [title]="detailsTabTitle" [disabled]="!enableDetailsTab">
            <ng-template kendoTabContent>
                <app-cbo-payments-details [cbo]="selectedCBO" [fromDateSelection]="fromDateSelection"
                    [toDateSelection]="toDateSelection" [organizationPaymentStatuses]="organizationPaymentStatuses">
                </app-cbo-payments-details>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>